import { QBoxStylesRFC } from "./QBoxStylesRFC";

export class QGetBoxStylesRFC extends QBoxStylesRFC {
  constructor() {
    super();
  }

  InitRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  SetParams(org, user, mode) {
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("mode", mode);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var success = r["success"];
    var theStream = r["data"];

    callBackObj.DownloadBoxStylesResult(success, theStream);
  }
}
